import { Badge } from '@/components/ui/badge';
import type { StatusBadgeProps } from '@/lib/types';

const doctorVariants: Record<string, { variant: 'secondary' | 'default' | 'outline'; label: string; className?: string }> = {
  unassigned: { variant: 'outline', label: 'Unassigned' },
  pending: { variant: 'secondary', label: 'Pending', className: 'bg-blue-100 text-blue-800' },
  in_review: { variant: 'default', label: 'In Review', className: 'bg-amber-100 text-amber-800' },
  reconciling: { variant: 'default', label: 'Reconciling', className: 'bg-purple-100 text-purple-800' },
  submitted: { variant: 'default', label: 'Submitted', className: 'bg-green-100 text-green-800' },
  completed: { variant: 'default', label: 'Completed', className: 'bg-green-100 text-green-800' },
  saved: { variant: 'default', label: 'Saved', className: 'bg-green-100 text-green-800' },
  not_reviewed: { variant: 'outline', label: 'Not Reviewed' },
};

const adminVariants: Record<string, { variant: 'outline' | 'secondary' | 'default'; label: string; className?: string }> = {
  unassigned: { variant: 'outline', label: 'Unassigned' },
  pending: { variant: 'secondary', label: 'Pending' },
  in_review: { variant: 'default', label: 'In Review', className: 'bg-amber-100 text-amber-800' },
  reconciling: { variant: 'default', label: 'Reconciling', className: 'bg-purple-100 text-purple-800' },
  submitted: { variant: 'secondary', label: 'Submitted', className: 'bg-indigo-100 text-indigo-800' },
  completed: { variant: 'default', label: 'Completed', className: 'bg-green-100 text-green-800' },
};

export function StatusBadge({ status, variant = 'doctor', label, className }: StatusBadgeProps) {
  const variants = variant === 'admin' ? adminVariants : doctorVariants;
  const config = variants[status] || { variant: 'outline' as const, label: status };

  return (
    <Badge variant={config.variant} className={className ?? config.className}>
      {label ?? config.label}
    </Badge>
  );
}
